(function () {
  window.SPCLST = window.SPCLST || {};
  window.SPCLST.modules = window.SPCLST.modules || {};

  window.SPCLST.modules.collection = function (helpers) {
    var query = helpers.query;
    var queryAll = helpers.queryAll;

    function initLiveSearchResults() {
      queryAll('.spclst-search-form').forEach(function (form) {
        if (form.getAttribute('data-spclst-search-live-initialized') === 'true') return;
        form.setAttribute('data-spclst-search-live-initialized', 'true');

        var input = query('.spclst-search-input', form);
        var searchPage = query('.spclst-search-page');
        var searchTimer = null;
        var activeController = null;
        var requestId = 0;

        if (!input || !searchPage || typeof window.fetch !== 'function' || typeof window.DOMParser !== 'function') return;

        function buildSearchUrl(term) {
          var url = new window.URL(form.getAttribute('action') || window.location.pathname, window.location.origin);
          var formData = new window.FormData(form);
          formData.set('q', term);
          url.search = '';
          formData.forEach(function (value, key) {
            url.searchParams.set(key, value);
          });
          return url;
        }

        function replaceSearchResults(term) {
          var url = buildSearchUrl(term);
          var currentRequestId = requestId + 1;
          requestId = currentRequestId;

          if (activeController) activeController.abort();
          activeController = window.AbortController ? new window.AbortController() : null;
          form.classList.add('is-loading');

          window
            .fetch(url.toString(), {
              signal: activeController ? activeController.signal : undefined,
              headers: { 'X-Requested-With': 'XMLHttpRequest' },
            })
            .then(function (response) {
              return response.text();
            })
            .then(function (html) {
              if (currentRequestId !== requestId) return;
              var doc = new window.DOMParser().parseFromString(html, 'text/html');
              var nextSearchPage = query('.spclst-search-page', doc);
              var currentSearchPage = query('.spclst-search-page');
              if (!nextSearchPage || !currentSearchPage) return;

              currentSearchPage.replaceWith(nextSearchPage);
              searchPage = nextSearchPage;
              window.history.replaceState({}, '', url.toString());

              if (window.SPCLST && window.SPCLST.modules && typeof window.SPCLST.modules.collection === 'function') {
                window.SPCLST.modules.collection(helpers);
              }
            })
            .catch(function (error) {
              if (error && error.name === 'AbortError') return;
              console.error('[SPCLST] Search update failed:', error);
            })
            .finally(function () {
              if (currentRequestId !== requestId) return;
              form.classList.remove('is-loading');
            });
        }

        input.addEventListener('input', function () {
          if (searchTimer) window.clearTimeout(searchTimer);
          searchTimer = window.setTimeout(function () {
            replaceSearchResults(input.value || '');
          }, 320);
        });
      });
    }

    initLiveSearchResults();

    // Align only siblings in the same visual grid row. Keep the existing
    // subtitle sizing and all option/price spacing inside each card intact.
    queryAll('.spclst-collection-grid-section .product-list-4').forEach(function (grid) {
      if (grid.spclstAlignHeadings) {
        grid.spclstAlignHeadings();
        return;
      }
      var alignmentFrame = null;
      var previousWidth = 0;

      function alignHeadings() {
        alignmentFrame = null;
        if (!grid.isConnected) return;
        var cards = queryAll('[data-spclst-collection-card]', grid);
        // Clear our previous measurements before reading natural heights so
        // a narrower title, new filter or breakpoint can shrink the row again.
        cards.forEach(function (card) {
          card.style.removeProperty('--spclst-row-heading-height');
        });
        var rows = [];
        cards.forEach(function (card) {
          if (!card.getClientRects().length) return;
          var heading = query('a.product-info-header', card);
          if (!heading) return;
          var top = card.getBoundingClientRect().top;
          var row = rows.find(function (candidate) { return Math.abs(candidate.top - top) < 2; });
          if (!row) {
            row = { top: top, height: 0, cards: [] };
            rows.push(row);
          }
          row.height = Math.max(row.height, heading.getBoundingClientRect().height);
          row.cards.push(card);
        });
        rows.forEach(function (row) {
          if (row.cards.length < 2) return;
          row.cards.forEach(function (card) {
            card.style.setProperty('--spclst-row-heading-height', Math.ceil(row.height) + 'px');
          });
        });
      }

      function requestAlignment() {
        if (alignmentFrame !== null) return;
        alignmentFrame = window.requestAnimationFrame(alignHeadings);
      }
      grid.spclstAlignHeadings = requestAlignment;
      if (typeof ResizeObserver === 'function') {
        new ResizeObserver(function (entries) {
          var width = entries[0].contentRect.width;
          // Height changes are our own work, not a reason to measure again.
          if (width === previousWidth) return;
          previousWidth = width;
          requestAlignment();
        }).observe(grid);
      } else {
        window.addEventListener('resize', requestAlignment);
      }
      if (typeof MutationObserver === 'function') {
        new MutationObserver(requestAlignment).observe(grid, {
          childList: true, subtree: true, attributes: true,
          attributeFilter: ['hidden', 'class'],
        });
      }
      if (document.fonts) {
        document.fonts.ready.then(requestAlignment);
        document.fonts.addEventListener('loadingdone', requestAlignment);
      }
      requestAlignment();
    });

    if (!window.SPCLST.collectionRefreshListenerBound) {
      window.SPCLST.collectionRefreshListenerBound = true;

      document.addEventListener('spclst:collection-refresh', function (event) {
        window.SPCLST.modules.collection(helpers);

        var sectionRoot = event.target.closest
          ? event.target.closest('.spclst-collection-grid-section')
          : null;

        if (sectionRoot) {
          sectionRoot.dispatchEvent(
            new window.CustomEvent('spclst:collection-items-appended', {
              detail: event.detail || {},
            })
          );
        }
      });
    }

    if (!window.SPCLST.collectionCardHoverOwnerBound) {
      window.SPCLST.collectionCardHoverOwnerBound = true;

      document.addEventListener('pointermove', function (event) {
        var activeCard = window.SPCLST.activeCollectionHoverCard;
        if (!activeCard) return;
        if (event.target && activeCard.contains(event.target)) return;

        activeCard.classList.remove('is-expanded');
        window.SPCLST.activeCollectionHoverCard = null;
      });
    }

    function normalizeIndex(value, length) {
      if (!length) return 0;
      if (value < 0) return length - 1;
      if (value >= length) return 0;
      return value;
    }

    function getCollectionHoverImageUrl(variants, selectedVariant, colorOptionIndex) {
      if (!selectedVariant) return '';

      if (selectedVariant.collection_hover_image_url) {
        return String(selectedVariant.collection_hover_image_url);
      }

      var productMatch = variants.find(function (candidate) {
        return candidate.collection_hover_image_url;
      });

      if (
        colorOptionIndex >= 0 &&
        selectedVariant.options &&
        selectedVariant.options[colorOptionIndex] != null
      ) {
        var selectedColor = selectedVariant.options[colorOptionIndex];
        var colorMatch = variants.find(function (candidate) {
          return (
            candidate.collection_hover_image_url &&
            candidate.options &&
            candidate.options[colorOptionIndex] === selectedColor
          );
        });

        if (colorMatch) {
          return String(colorMatch.collection_hover_image_url);
        }

        return productMatch ? String(productMatch.collection_hover_image_url) : '';
      }

      return productMatch ? String(productMatch.collection_hover_image_url) : '';
    }

    function formatMoney(cents) {
      if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
        return window.Shopify.formatMoney(cents);
      }

      var numeric = Number(cents || 0) / 100;
      return '$' + numeric.toFixed(2);
    }

    function getCompareAtPrice(variant) {
      return Number((variant && variant.compare_at_price) || 0);
    }

    function variantIsOnSale(variant) {
      if (!variant) return false;
      return getCompareAtPrice(variant) > Number(variant.price || 0);
    }

    function getVariantSalePercent(variant) {
      if (!variantIsOnSale(variant)) return 0;

      var compareAtPrice = getCompareAtPrice(variant);
      var salePrice = Number(variant.price || 0);
      return Math.round(((compareAtPrice - salePrice) / compareAtPrice) * 100);
    }

    function selectionMatchesVariant(variant, selectedOptions) {
      if (!variant || !variant.options) return false;

      return variant.options.every(function (optionValue, optionIndex) {
        var key = String(optionIndex);
        return !selectedOptions[key] || selectedOptions[key] === optionValue;
      });
    }

    function getVariantMediaId(variant) {
      if (!variant) return null;
      return variant.featured_media_id || variant.featured_image_id || null;
    }

    function getSwatchFallback(value) {
      var normalized = String(value || '')
        .trim()
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, ' ');

      var map = {
        ash: '#beb9b0',
        beige: '#cbc1ad',
        black: '#000000',
        blue: '#405d8d',
        brown: '#6b5545',
        charcoal: '#6b6464',
        cream: '#e4ddd1',
        'dark army': '#545144',
        'faded army': '#526456',
        fog: '#dad9db',
        grey: '#808080',
        gray: '#808080',
        green: '#526456',
        khaki: '#9a927b',
        leaf: '#817d6a',
        navy: '#545a92',
        olive: '#6b7152',
        orange: '#f93f02',
        brick: '#f93f02',
        'ranger green': '#706e5c',
        rust: '#f93f02',
        sand: '#b7ae99',
        'spc lst red': '#f93f02',
        stone: '#9a9187',
        taupe: '#8f8782',
        'true black': '#000000',
        white: '#dad9db',
      };

      if (map[normalized]) return map[normalized];

      if (
        normalized.indexOf('red') !== -1 ||
        normalized.indexOf('orange') !== -1 ||
        normalized.indexOf('brick') !== -1 ||
        normalized.indexOf('rust') !== -1
      ) return '#f93f02';
      if (normalized.indexOf('fog') !== -1 || normalized.indexOf('white') !== -1) return '#dad9db';
      if (normalized.indexOf('olive') !== -1) return '#6b7152';
      if (normalized.indexOf('black') !== -1) return '#000000';
      if (normalized.indexOf('grey') !== -1 || normalized.indexOf('gray') !== -1) return '#808080';
      if (normalized.indexOf('sand') !== -1 || normalized.indexOf('tan') !== -1) return '#b7ae99';
      if (normalized.indexOf('stone') !== -1) return '#9a9187';
      if (normalized.indexOf('taupe') !== -1) return '#8f8782';
      if (normalized.indexOf('army') !== -1 || normalized.indexOf('green') !== -1) return '#526456';
      if (normalized.indexOf('navy') !== -1) return '#545a92';

      return '#b4b0a5';
    }

    function hydrateFallbackSwatches(cardRoot) {
      queryAll('[data-spclst-swatch-name]', cardRoot).forEach(function (swatch) {
        if (swatch.style.getPropertyValue('--spclst-swatch-background')) return;
        swatch.style.setProperty('--spclst-swatch-background', getSwatchFallback(swatch.getAttribute('data-spclst-swatch-name')));
      });
    }

    var FILTER_QUERY_PARAMS = {
      category: 'spclst_category',
      material: 'spclst_material',
      color: 'spclst_color',
    };

    function splitFilterValues(rawValues) {
      if (!rawValues) return [];

      return uniqueValues(
        String(rawValues)
        .split('||')
        .map(function (value) {
          return String(value || '').trim();
        })
        .filter(function (value) {
          return value.length > 0;
        })
      );
    }

    function uniqueValues(values) {
      var normalizedValues = [];

      (values || []).forEach(function (value) {
        var normalizedValue = String(value || '').trim();
        if (!normalizedValue || normalizedValues.indexOf(normalizedValue) !== -1) return;
        normalizedValues.push(normalizedValue);
      });

      return normalizedValues;
    }

    function getQueryParamValues(searchParams, paramName) {
      if (!searchParams || !paramName) return [];
      return uniqueValues(searchParams.getAll(paramName));
    }

    function setQueryParamValues(searchParams, paramName, values) {
      if (!searchParams || !paramName) return;
      searchParams.delete(paramName);
      uniqueValues(values).forEach(function (value) {
        searchParams.append(paramName, value);
      });
    }

    function getCollectionFilterState() {
      if (typeof window.URL !== 'function') {
        return {
          category: [],
          material: [],
          color: [],
        };
      }

      var currentUrl = new window.URL(window.location.href);
      var state = {};

      Object.keys(FILTER_QUERY_PARAMS).forEach(function (group) {
        state[group] = getQueryParamValues(currentUrl.searchParams, FILTER_QUERY_PARAMS[group]);

        if (group === 'color') {
          state[group] = state[group].map(function (value) {
            return value === 'grey' ? 'gray' : value;
          });
        }
      });

      return state;
    }

    function initStickyFilterPosition(menuRoot) {
      if (!menuRoot || menuRoot.getAttribute('data-spclst-sticky-initialized') === 'true') return;

      var sectionRoot = menuRoot.closest('.spclst-collection-grid-section');
      var headerRoot = query('[data-spclst-header]') || query('.navbar.spclst-nav-home');
      var stickySentinel = query('[data-spclst-filter-sentinel]', sectionRoot);

      if (!sectionRoot || !headerRoot) return;

      menuRoot.setAttribute('data-spclst-sticky-initialized', 'true');

      var mainContentRoot = query('#MainContent') || query('main');
      var scrollTargets = [window];
      var ticking = false;
      var transitionTrackingFrame = null;
      var transitionTrackingActive = false;

      if (
        mainContentRoot &&
        mainContentRoot !== window &&
        mainContentRoot !== document.body &&
        mainContentRoot !== document.documentElement
      ) {
        scrollTargets.push(mainContentRoot);
      }

      function getActiveNavRoot() {
        var desktopViewport = window.matchMedia('(min-width: 992px)').matches;

        return desktopViewport
          ? query('[data-spclst-desktop-nav-row]', headerRoot) || query('.desktop-nav', headerRoot) || headerRoot
          : query('.mobile-nav', headerRoot) || headerRoot;
      }

      function getReservedNavHeight() {
        var activeNavRoot = getActiveNavRoot();
        var activeNavHeight = activeNavRoot.offsetHeight || activeNavRoot.getBoundingClientRect().height || 0;
        var headerHeight = headerRoot.offsetHeight || headerRoot.getBoundingClientRect().height || 0;

        return Math.max(activeNavHeight, headerHeight);
      }

      function getHeaderTranslateY() {
        var computedStyle = window.getComputedStyle(headerRoot);
        var transformValue = computedStyle.transform || computedStyle.webkitTransform || 'none';

        if (!transformValue || transformValue === 'none') return 0;

        var matrix3dMatch = transformValue.match(/^matrix3d\((.+)\)$/);
        if (matrix3dMatch) {
          var matrix3dValues = matrix3dMatch[1].split(',').map(function (value) {
            return parseFloat(value.trim());
          });

          return Number.isFinite(matrix3dValues[13]) ? matrix3dValues[13] : 0;
        }

        var matrixMatch = transformValue.match(/^matrix\((.+)\)$/);
        if (matrixMatch) {
          var matrixValues = matrixMatch[1].split(',').map(function (value) {
            return parseFloat(value.trim());
          });

          return Number.isFinite(matrixValues[5]) ? matrixValues[5] : 0;
        }

        return 0;
      }

      function getVisibleNavHeight() {
        var activeNavRoot = getActiveNavRoot();
        var reservedNavHeight = getReservedNavHeight();
        var activeNavRect = activeNavRoot.getBoundingClientRect();
        var headerRect = headerRoot.getBoundingClientRect();
        var activeNavBottom = activeNavRect.bottom;
        var headerBottom = headerRect.bottom;
        var visibleBottom = Math.max(
          Number.isFinite(activeNavBottom) ? activeNavBottom : 0,
          Number.isFinite(headerBottom) ? headerBottom : 0
        );

        if (!reservedNavHeight) return 0;

        if (!Number.isFinite(visibleBottom)) {
          var translateY = getHeaderTranslateY();
          if (!Number.isFinite(translateY)) translateY = 0;
          return Math.max(0, Math.min(reservedNavHeight, reservedNavHeight + Math.min(0, translateY)));
        }

        return Math.max(0, Math.min(reservedNavHeight, visibleBottom));
      }

      function shouldStick(visibleNavHeight) {
        if (!stickySentinel) return true;

        return stickySentinel.getBoundingClientRect().top <= visibleNavHeight + 0.5;
      }

      function getDocumentScrollTop() {
        var scrollingElement = document.scrollingElement || document.documentElement || document.body;
        return scrollingElement ? scrollingElement.scrollTop || window.pageYOffset || 0 : window.pageYOffset || 0;
      }

      function getRestingFilterGap() {
        var computedStyle = window.getComputedStyle(sectionRoot);
        var explicitGap = parseFloat(computedStyle.getPropertyValue('--spclst-filter-top-rest-gap'));

        if (Number.isFinite(explicitGap) && explicitGap > 0) return explicitGap;

        return 0;
      }

      function updateStickyPosition() {
        var reservedNavHeight = getReservedNavHeight();
        var visibleNavHeight = getVisibleNavHeight();
        var isStickyActive = shouldStick(visibleNavHeight);
        var stickyGap = isStickyActive && getDocumentScrollTop() <= 1 ? getRestingFilterGap() : 0;

        sectionRoot.style.setProperty('--spclst-nav-reserved-space', reservedNavHeight + 'px');
        sectionRoot.style.setProperty('--spclst-nav-visible-height', visibleNavHeight + 'px');
        sectionRoot.style.setProperty('--spclst-filter-sticky-gap', stickyGap + 'px');
        menuRoot.classList.toggle('is-nav-visible', visibleNavHeight > 0.5);
        menuRoot.classList.toggle('is-stuck', isStickyActive);
      }

      function requestStickyPositionUpdate() {
        if (ticking) return;

        ticking = true;
        window.requestAnimationFrame(function () {
          updateStickyPosition();
          ticking = false;
        });
      }

      function trackNavTransition() {
        if (!transitionTrackingActive) return;

        updateStickyPosition();
        transitionTrackingFrame = window.requestAnimationFrame(trackNavTransition);
      }

      function startTransitionTracking() {
        if (transitionTrackingActive) return;

        transitionTrackingActive = true;
        trackNavTransition();
      }

      function stopTransitionTracking() {
        transitionTrackingActive = false;

        if (transitionTrackingFrame) {
          window.cancelAnimationFrame(transitionTrackingFrame);
          transitionTrackingFrame = null;
        }

        updateStickyPosition();
      }

      scrollTargets.forEach(function (target) {
        target.addEventListener('scroll', requestStickyPositionUpdate, { passive: true });
      });

      window.addEventListener('resize', requestStickyPositionUpdate);
      window.addEventListener('orientationchange', requestStickyPositionUpdate);

      if (typeof MutationObserver === 'function') {
        var navMutationObserver = new MutationObserver(requestStickyPositionUpdate);
        navMutationObserver.observe(headerRoot, {
          attributes: true,
          attributeFilter: ['class', 'style'],
        });
      }

      if (typeof ResizeObserver === 'function') {
        var navResizeObserver = new ResizeObserver(requestStickyPositionUpdate);
        navResizeObserver.observe(headerRoot);
      }

      ['transitionrun', 'transitionstart'].forEach(function (eventName) {
        headerRoot.addEventListener(eventName, startTransitionTracking);
      });

      ['transitionend', 'transitioncancel'].forEach(function (eventName) {
        headerRoot.addEventListener(eventName, stopTransitionTracking);
      });

      requestStickyPositionUpdate();
    }

    function initGallery(cardRoot) {
      var galleryRoot = query('[data-spclst-plp-gallery]', cardRoot);
      if (!galleryRoot) return null;

      var slides = queryAll('[data-spclst-plp-media-slide]', galleryRoot);
      var thumbs = queryAll('[data-spclst-plp-thumb]', galleryRoot);
      var prevButton = query('[data-spclst-plp-prev]', galleryRoot);
      var nextButton = query('[data-spclst-plp-next]', galleryRoot);
      var lifestyleHover = query('[data-spclst-plp-lifestyle-hover]', galleryRoot);
      var lifestyleHoverArt = query('[data-spclst-plp-lifestyle-hover-art]', galleryRoot);

      if (!slides.length) return null;

      var currentIndex = 0;
      var touchStartX = 0;
      var touchStartY = 0;

      slides.forEach(function (slide, slideIndex) {
        if (slide.classList.contains('is-active')) currentIndex = slideIndex;
      });

      function setActive(index) {
        currentIndex = normalizeIndex(index, slides.length);

        slides.forEach(function (slide, slideIndex) {
          var isActive = slideIndex === currentIndex;
          slide.classList.toggle('is-active', isActive);
          slide.setAttribute('aria-hidden', isActive ? 'false' : 'true');
        });

        thumbs.forEach(function (thumb) {
          var isActive = String(thumb.getAttribute('data-media-id')) === String(slides[currentIndex].getAttribute('data-media-id'));
          thumb.classList.toggle('is-active', isActive);
          thumb.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        });
      }

      function setByMediaId(mediaId) {
        if (!mediaId) return;

        var matchIndex = slides.findIndex(function (slide) {
          return String(slide.getAttribute('data-media-id')) === String(mediaId);
        });

        if (matchIndex >= 0) setActive(matchIndex);
      }

      function getActiveMediaId() {
        if (!slides[currentIndex]) return null;
        return slides[currentIndex].getAttribute('data-media-id');
      }

      function showLifestyleImage(imageUrl) {
        if (!lifestyleHover || !lifestyleHoverArt || !imageUrl) return false;

        lifestyleHoverArt.style.backgroundImage = 'url(' + JSON.stringify(String(imageUrl)) + ')';
        lifestyleHover.classList.add('is-active');
        return true;
      }

      function hideLifestyleImage() {
        if (!lifestyleHover) return;

        lifestyleHover.classList.remove('is-active');
      }

      galleryRoot.addEventListener('click', function (event) {
        var prevTrigger = event.target.closest('[data-spclst-plp-prev]');
        var nextTrigger = event.target.closest('[data-spclst-plp-next]');
        var thumbTrigger = event.target.closest('[data-spclst-plp-thumb]');

        if (!prevTrigger && !nextTrigger && !thumbTrigger) return;

        event.preventDefault();
        event.stopPropagation();

        if (prevTrigger) {
          setActive(currentIndex - 1);
          return;
        }

        if (nextTrigger) {
          setActive(currentIndex + 1);
          return;
        }

        if (thumbTrigger) {
          setByMediaId(thumbTrigger.getAttribute('data-media-id'));
        }
      });

      galleryRoot.addEventListener(
        'touchstart',
        function (event) {
          if (!event.touches || !event.touches.length) return;
          touchStartX = event.touches[0].clientX;
          touchStartY = event.touches[0].clientY;
        },
        { passive: true }
      );

      galleryRoot.addEventListener(
        'touchend',
        function (event) {
          if (!event.changedTouches || !event.changedTouches.length) return;

          var touchEndX = event.changedTouches[0].clientX;
          var touchEndY = event.changedTouches[0].clientY;
          var deltaX = touchEndX - touchStartX;
          var deltaY = touchEndY - touchStartY;
          var isHorizontalSwipe = Math.abs(deltaX) > 48 && Math.abs(deltaX) > Math.abs(deltaY) * 1.15;

          if (!isHorizontalSwipe) return;

          if (deltaX < 0) {
            setActive(currentIndex + 1);
          } else {
            setActive(currentIndex - 1);
          }
        },
        { passive: true }
      );

      setActive(currentIndex);

      return {
        getActiveMediaId: getActiveMediaId,
        hideLifestyleImage: hideLifestyleImage,
        setByMediaId: setByMediaId,
        showLifestyleImage: showLifestyleImage,
      };
    }

    queryAll('[data-spclst-filter-menu]').forEach(function (menuRoot) {
      if (menuRoot.getAttribute('data-spclst-filter-initialized') === 'true') return;
      menuRoot.setAttribute('data-spclst-filter-initialized', 'true');

      var toggle = query('[data-spclst-filter-toggle]', menuRoot);
      var panel = query('[data-spclst-filter-panel]', menuRoot);
      var sectionRoot = menuRoot.closest('.spclst-collection-grid-section');
      var clearAllLink = query('[data-spclst-filter-clear-all]', menuRoot);
      var activeSummaryRoot = query('[data-spclst-filter-summary]', menuRoot);
      var sortForm = query('[data-spclst-sort-form]', menuRoot);
      var filterLabelLookup = {};
      var filterPanelCloseTimer = null;

      if (!toggle || !panel || !sectionRoot) return;

      queryAll('[data-spclst-filter-item]', menuRoot).forEach(function (item) {
        var group = item.getAttribute('data-spclst-filter-group');
        var value = item.getAttribute('data-spclst-filter-value');
        var explicitLabel = item.getAttribute('data-spclst-filter-label');
        var labelNode = query('[data-spclst-filter-option-label]', item);
        var label = explicitLabel
          ? String(explicitLabel).trim()
          : labelNode
            ? String(labelNode.textContent || '').trim()
            : String(item.textContent || '').trim();

        if (!group || !value || !label) return;
        filterLabelLookup[group + '::' + value] = label;
      });

      initStickyFilterPosition(menuRoot);

      function clearFilterPanelCloseTimer() {
        if (!filterPanelCloseTimer) return;
        window.clearTimeout(filterPanelCloseTimer);
        filterPanelCloseTimer = null;
      }

      function setOpen(open) {
        clearFilterPanelCloseTimer();

        if (open) {
          panel.hidden = false;
          panel.classList.remove('is-closing');
          toggle.setAttribute('aria-expanded', 'true');
          menuRoot.classList.add('is-open');
          void panel.offsetWidth;
          panel.classList.add('is-open');
          return;
        }

        toggle.setAttribute('aria-expanded', 'false');
        menuRoot.classList.remove('is-open');

        if (panel.hidden) {
          panel.classList.remove('is-open');
          panel.classList.remove('is-closing');
          return;
        }

        panel.classList.remove('is-open');
        panel.classList.add('is-closing');

        filterPanelCloseTimer = window.setTimeout(function () {
          panel.classList.remove('is-closing');
          panel.hidden = true;
          filterPanelCloseTimer = null;
        }, 190);
      }

      function hasActiveCollectionFilters(state) {
        return Object.keys(FILTER_QUERY_PARAMS).some(function (group) {
          return state[group] && state[group].length > 0;
        });
      }

      function matchesAnySelectedValue(cardValues, selectedValues) {
        if (!selectedValues.length) return true;

        return selectedValues.some(function (selectedValue) {
          return cardValues.indexOf(selectedValue) !== -1;
        });
      }

      function syncSortFormInputs(state) {
        if (!sortForm) return;

        queryAll('[data-spclst-filter-state-input]', sortForm).forEach(function (input) {
          input.remove();
        });

        Object.keys(FILTER_QUERY_PARAMS).forEach(function (group) {
          var paramName = FILTER_QUERY_PARAMS[group];
          (state[group] || []).forEach(function (value) {
            var input = document.createElement('input');
            input.type = 'hidden';
            input.name = paramName;
            input.value = value;
            input.setAttribute('data-spclst-filter-state-input', 'true');
            sortForm.appendChild(input);
          });
        });
      }

      function syncPaginationLinks(state) {
        queryAll('.pagination a[href]', sectionRoot).forEach(function (link) {
          var targetUrl = new window.URL(link.getAttribute('href'), window.location.origin);

          Object.keys(FILTER_QUERY_PARAMS).forEach(function (group) {
            setQueryParamValues(targetUrl.searchParams, FILTER_QUERY_PARAMS[group], state[group] || []);
          });

          link.setAttribute('href', targetUrl.toString());
        });
      }

      function renderActiveSummary(state) {
        if (!activeSummaryRoot) return;

        var groupsInOrder = ['category', 'material', 'color'];
        var chipsMarkup = [];

        groupsInOrder.forEach(function (group) {
          (state[group] || []).forEach(function (value) {
            var lookupKey = group + '::' + value;
            var label = filterLabelLookup[lookupKey] || value.replace(/[-_]+/g, ' ');

            chipsMarkup.push(
              '<button type="button" class="spclst-filter-active-chip" data-spclst-filter-active-chip data-spclst-filter-group="' +
                group +
                '" data-spclst-filter-value="' +
                value +
                '">' +
                '<span class="spclst-filter-active-chip-label">' +
                label +
                '</span>' +
                '<span class="spclst-filter-active-chip-remove" aria-hidden="true">×</span>' +
              '</button>'
            );
          });
        });

        activeSummaryRoot.innerHTML = chipsMarkup.join('');
        activeSummaryRoot.hidden = chipsMarkup.length === 0;
      }

      function syncFilterControls(state) {
        queryAll('[data-spclst-filter-item]', menuRoot).forEach(function (item) {
          var group = item.getAttribute('data-spclst-filter-group');
          var value = item.getAttribute('data-spclst-filter-value');
          var isActive = !!(group && value && state[group] && state[group].indexOf(value) !== -1);

          item.classList.toggle('is-active', isActive);
          item.setAttribute('data-spclst-filter-active', isActive ? 'true' : 'false');

          if (item.tagName === 'BUTTON') {
            item.setAttribute('aria-pressed', isActive ? 'true' : 'false');
          } else if (item.tagName === 'A') {
            if (isActive) {
              item.setAttribute('aria-current', 'true');
            } else {
              item.removeAttribute('aria-current');
            }
          }
        });

        if (clearAllLink) {
          var clearUrl = new window.URL(clearAllLink.getAttribute('href') || window.location.href, window.location.origin);
          clearUrl.searchParams.delete('page');

          Object.keys(FILTER_QUERY_PARAMS).forEach(function (group) {
            clearUrl.searchParams.delete(FILTER_QUERY_PARAMS[group]);
          });

          clearAllLink.setAttribute('href', clearUrl.toString());
          clearAllLink.classList.toggle('is-idle', !hasActiveCollectionFilters(state));
        }

        syncSortFormInputs(state);
        syncPaginationLinks(state);
        renderActiveSummary(state);
      }

      function applyCollectionFilters(event) {
        var state = getCollectionFilterState();
        var visibleCount = 0;
        var activeColorFilters = state.color || [];
        var cards = queryAll('[data-spclst-collection-card]', sectionRoot);
        var shouldSyncCardSelections = !(
          event &&
          event.type === 'spclst:collection-items-appended'
        );

        cards.forEach(function (card) {
          var collectionHandles = splitFilterValues(card.getAttribute('data-spclst-collection-handles'));
          var colorCategories = splitFilterValues(card.getAttribute('data-spclst-color-categories')).map(function (value) {
            return value === 'grey' ? 'gray' : value;
          });
          var isVisible =
            matchesAnySelectedValue(collectionHandles, state.category || []) &&
            matchesAnySelectedValue(collectionHandles, state.material || []) &&
            matchesAnySelectedValue(colorCategories, state.color || []);

          card.hidden = !isVisible;
          card.classList.toggle('is-filter-hidden', !isVisible);
          card.style.display = isVisible ? '' : 'none';

          if (
            shouldSyncCardSelections &&
            typeof card.spclstApplyColorFilterSelection === 'function'
          ) {
            card.spclstApplyColorFilterSelection(activeColorFilters);
          }

          if (isVisible) visibleCount += 1;
        });

        var emptyState = query('[data-spclst-filter-empty]', sectionRoot);
        if (emptyState) {
          emptyState.hidden = visibleCount > 0;
        }

        sectionRoot.classList.toggle(
          'spclst-filter-results-fit-current-page',
          hasActiveCollectionFilters(state) && visibleCount < cards.length
        );

        syncFilterControls(state);
      }

      function updateFilterState(group, value) {
        var paramName = FILTER_QUERY_PARAMS[group];
        if (!paramName || !value || typeof window.URL !== 'function') return;

        var nextUrl = new window.URL(window.location.href);
        var currentValues = getQueryParamValues(nextUrl.searchParams, paramName);
        var valueIndex = currentValues.indexOf(value);

        nextUrl.searchParams.delete('page');

        if (valueIndex === -1) {
          currentValues.push(value);
        } else {
          currentValues.splice(valueIndex, 1);
        }

        setQueryParamValues(nextUrl.searchParams, paramName, currentValues);
        window.history.pushState({}, '', nextUrl.toString());
        applyCollectionFilters();
      }

      function clearAllFilters() {
        if (typeof window.URL !== 'function') return;

        var nextUrl = new window.URL(window.location.href);
        nextUrl.searchParams.delete('page');

        Object.keys(FILTER_QUERY_PARAMS).forEach(function (group) {
          nextUrl.searchParams.delete(FILTER_QUERY_PARAMS[group]);
        });

        window.history.pushState({}, '', nextUrl.toString());
        applyCollectionFilters();
      }

      function isModifiedClick(event) {
        return event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button > 0;
      }

      function shouldAutoCloseOnPointerBelow(clientY) {
        if (toggle.getAttribute('aria-expanded') !== 'true') return false;
        if (!window.matchMedia('(min-width: 992px) and (hover: hover) and (pointer: fine)').matches) return false;
        if (typeof clientY !== 'number') return false;

        var toggleRect = toggle.getBoundingClientRect();
        var panelRect = panel.getBoundingClientRect();
        var menuBottom = Math.max(toggleRect.bottom, panelRect.bottom);

        return clientY > menuBottom + 0.5;
      }

      setOpen(false);
      applyCollectionFilters();

      toggle.addEventListener('click', function (event) {
        event.preventDefault();
        setOpen(toggle.getAttribute('aria-expanded') !== 'true');
      });

      queryAll('[data-spclst-filter-item]', menuRoot).forEach(function (item) {
        item.addEventListener('click', function (event) {
          if (isModifiedClick(event)) return;
          event.preventDefault();

          updateFilterState(item.getAttribute('data-spclst-filter-group'), item.getAttribute('data-spclst-filter-value'));
        });
      });

      if (clearAllLink) {
        clearAllLink.addEventListener('click', function (event) {
          if (isModifiedClick(event)) return;
          event.preventDefault();
          clearAllFilters();
        });
      }

      if (activeSummaryRoot) {
        activeSummaryRoot.addEventListener('click', function (event) {
          var chip = event.target.closest('[data-spclst-filter-active-chip]');
          if (!chip) return;

          event.preventDefault();
          event.stopPropagation();

          updateFilterState(chip.getAttribute('data-spclst-filter-group'), chip.getAttribute('data-spclst-filter-value'));
        });
      }

      document.addEventListener('click', function (event) {
        if (menuRoot.contains(event.target)) return;
        setOpen(false);
      });

      document.addEventListener('keydown', function (event) {
        if (event.key !== 'Escape') return;
        setOpen(false);
      });

      document.addEventListener('pointermove', function (event) {
        if (!shouldAutoCloseOnPointerBelow(event.clientY)) return;
        setOpen(false);
      });

      window.addEventListener('popstate', applyCollectionFilters);
      sectionRoot.addEventListener('spclst:collection-items-appended', applyCollectionFilters);
    });

    queryAll('[data-spclst-collection-card]').forEach(function (cardRoot) {
      if (cardRoot.getAttribute('data-spclst-initialized') === 'true') return;
      cardRoot.setAttribute('data-spclst-initialized', 'true');
      hydrateFallbackSwatches(cardRoot);

      var hoverRoot =
        query('.spclst-plp-media-shell', cardRoot) || query('.product-thumb-big', cardRoot) || cardRoot;
      var collapseTimer = null;
      var cardPointerInside = false;
      var galleryHoverPreviewActive = false;
      var selectedBaseMediaId = null;
      var sectionRoot = cardRoot.closest('.spclst-collection-grid-section');
      var currentVariant = null;
      var colorGroup = query('[data-spclst-color-group]', cardRoot);
      var colorOptionIndex = colorGroup
        ? parseInt(colorGroup.getAttribute('data-spclst-color-option-index') || '-1', 10)
        : -1;

      function shouldUseDesktopHoverNextImage() {
        return !!(
          sectionRoot &&
          sectionRoot.classList.contains('spclst-collection-grid-section--hover-next-image') &&
          window.matchMedia('(min-width: 992px) and (hover: hover) and (pointer: fine)').matches
        );
      }

      function shouldUseCardHoverExpansion() {
        return window.matchMedia('(min-width: 768px) and (hover: hover) and (pointer: fine)').matches;
      }

      function setHoverState(hovered) {
        cardRoot.classList.toggle('is-gallery-hovered', !!hovered);
      }

      function setExpanded(expanded) {
        if (!shouldUseCardHoverExpansion()) {
          if (collapseTimer) {
            window.clearTimeout(collapseTimer);
            collapseTimer = null;
          }
          cardRoot.classList.remove('is-expanded');
          if (window.SPCLST.activeCollectionHoverCard === cardRoot) {
            window.SPCLST.activeCollectionHoverCard = null;
          }
          return;
        }

        if (expanded) {
          if (collapseTimer) {
            window.clearTimeout(collapseTimer);
            collapseTimer = null;
          }
          if (
            window.SPCLST.activeCollectionHoverCard &&
            window.SPCLST.activeCollectionHoverCard !== cardRoot
          ) {
            window.SPCLST.activeCollectionHoverCard.classList.remove('is-expanded');
          }
          window.SPCLST.activeCollectionHoverCard = cardRoot;
          cardRoot.classList.add('is-expanded');
          return;
        }

        if (collapseTimer) window.clearTimeout(collapseTimer);
        collapseTimer = window.setTimeout(function () {
          cardRoot.classList.remove('is-expanded');
          if (window.SPCLST.activeCollectionHoverCard === cardRoot) {
            window.SPCLST.activeCollectionHoverCard = null;
          }
          collapseTimer = null;
        }, 180);
      }

      function resetDesktopHoverPreview() {
        setHoverState(false);
        galleryHoverPreviewActive = false;
        cardRoot.classList.remove('is-lifestyle-hovered');
        if (gallery) gallery.hideLifestyleImage();
      }

      function showDesktopHoverPreview() {
        if (!gallery || !shouldUseDesktopHoverNextImage()) return;
        if (galleryHoverPreviewActive) return;

        var lifestyleImageUrl = getCollectionHoverImageUrl(variants, currentVariant, colorOptionIndex);
        if (!lifestyleImageUrl) {
          gallery.hideLifestyleImage();
          cardRoot.classList.remove('is-lifestyle-hovered');
          return;
        }

        galleryHoverPreviewActive = gallery.showLifestyleImage(lifestyleImageUrl);
        cardRoot.classList.toggle('is-lifestyle-hovered', galleryHoverPreviewActive);
      }

      function pointerIsWithinHoverRoot(clientX, clientY) {
        if (typeof clientX !== 'number' || typeof clientY !== 'number') return false;
        var rect = hoverRoot.getBoundingClientRect();

        return clientX >= rect.left && clientX <= rect.right && clientY >= rect.top && clientY <= rect.bottom;
      }

      hoverRoot.addEventListener('pointerenter', function () {
        setHoverState(true);
        setExpanded(true);
        showDesktopHoverPreview();
      });

      hoverRoot.addEventListener('pointermove', function () {
        setHoverState(true);
        setExpanded(true);
        showDesktopHoverPreview();
      });

      hoverRoot.addEventListener('pointerleave', function (event) {
        if (event.relatedTarget && hoverRoot.contains(event.relatedTarget)) return;
        if (pointerIsWithinHoverRoot(event.clientX, event.clientY)) return;
        resetDesktopHoverPreview();
      });

      cardRoot.addEventListener('pointerenter', function () {
        cardPointerInside = true;
        setExpanded(true);
      });

      cardRoot.addEventListener('pointermove', function (event) {
        cardPointerInside = true;
        setExpanded(true);
        if (pointerIsWithinHoverRoot(event.clientX, event.clientY)) return;
        if (!cardRoot.classList.contains('is-gallery-hovered') && !galleryHoverPreviewActive) return;
        resetDesktopHoverPreview();
      });

      cardRoot.addEventListener('pointerout', function (event) {
        if (event.relatedTarget && cardRoot.contains(event.relatedTarget)) return;
        cardPointerInside = false;
        resetDesktopHoverPreview();
        setExpanded(false);
      });

      cardRoot.addEventListener('focusin', function () {
        setExpanded(true);
      });

      cardRoot.addEventListener('focusout', function () {
        window.requestAnimationFrame(function () {
          if (cardRoot.contains(document.activeElement)) return;
          if (cardPointerInside) return;
          resetDesktopHoverPreview();
          setExpanded(false);
        });
      });

      var variantsJson = query('[data-spclst-variants]', cardRoot);
      if (!variantsJson) return;

      var variants = [];
      try {
        variants = JSON.parse(variantsJson.textContent || '[]');
      } catch (error) {
        variants = [];
      }

      if (!variants.length) return;

      var gallery = initGallery(cardRoot);
      var optionButtons = queryAll('[data-option-index][data-option-value]', cardRoot);
      var variantInput = query('[data-spclst-plp-variant-input]', cardRoot);
      var priceEl = query('[data-spclst-plp-price]', cardRoot);
      var comparePriceEl = query('[data-spclst-plp-compare-price]', cardRoot);
      var priceWrapEl = query('[data-spclst-plp-price-wrap]', cardRoot);
      var saleBadgeEl = query('[data-spclst-plp-sale-badge]', cardRoot);
      var hasSaleTreatment = Boolean(comparePriceEl || priceWrapEl || saleBadgeEl);
      var addButton = query('[data-spclst-plp-add]', cardRoot);
      var addButtonLabel = query('[data-spclst-plp-add-label]', cardRoot);
      var outOfStockLabel = query('[data-spclst-plp-out-label]', cardRoot);
      var colorLabel = query('[data-spclst-color-label]', cardRoot);
      var defaultVariantId = cardRoot.getAttribute('data-spclst-default-variant-id');

      function updateOptionVisualState(button, isActive) {
        var optionKind = button.getAttribute('data-option-kind');
        button.classList.toggle('sf-active', isActive);
        button.setAttribute('aria-pressed', isActive ? 'true' : 'false');

        if (optionKind === 'color') {
          button.classList.toggle('spclst-color-choice--active', isActive);
          var colorText = query('.colorblock', button);
          if (colorText) colorText.classList.toggle('sf-active', isActive);
          return;
        }

        button.classList.toggle('pdpdraftproductsizeselected', isActive);
        button.classList.toggle('pdpdraftproductsizeselector', !isActive);
        var sizeText = query('.plpsizeselectortext', button);
        if (sizeText) sizeText.classList.toggle('sf-active', isActive);
      }

      function getSelectedOptions() {
        var selected = {};

        optionButtons.forEach(function (button) {
          if (!button.classList.contains('is-active')) return;
          selected[button.getAttribute('data-option-index')] = button.getAttribute('data-option-value');
        });

        return selected;
      }

      function findVariant(selectedOptions) {
        return (
          variants.find(function (variant) {
            return selectionMatchesVariant(variant, selectedOptions);
          }) || null
        );
      }

      function findVariantById(variantId) {
        if (!variantId) return null;

        return (
          variants.find(function (variant) {
            return String(variant.id) === String(variantId);
          }) || null
        );
      }

      function findBestAvailableVariant(selectedOptions) {
        return (
          variants.find(function (variant) {
            return variant.available && selectionMatchesVariant(variant, selectedOptions);
          }) ||
          variants.find(function (variant) {
            return selectionMatchesVariant(variant, selectedOptions);
          }) ||
          variants[0] ||
          null
        );
      }

      function findBestVariantForColor(optionIndex, optionValue, selectedOptions) {
        var preferredSelection = Object.assign({}, selectedOptions);
        preferredSelection[optionIndex] = optionValue;

        return (
          variants.find(function (variant) {
            return variant.available && selectionMatchesVariant(variant, preferredSelection);
          }) ||
          variants.find(function (variant) {
            return selectionMatchesVariant(variant, preferredSelection);
          }) ||
          variants.find(function (variant) {
            return variant.available && variant.options && variant.options[optionIndex] === optionValue;
          }) ||
          variants.find(function (variant) {
            return variant.options && variant.options[optionIndex] === optionValue;
          }) ||
          null
        );
      }

      function findFirstColorButtonForCategory(colorCategoryTokens) {
        if (!colorCategoryTokens || !colorCategoryTokens.length) return null;

        for (var colorTokenIndex = 0; colorTokenIndex < colorCategoryTokens.length; colorTokenIndex += 1) {
          var colorToken = colorCategoryTokens[colorTokenIndex];

          for (var buttonIndex = 0; buttonIndex < optionButtons.length; buttonIndex += 1) {
            var button = optionButtons[buttonIndex];

            if (button.getAttribute('data-option-kind') !== 'color') continue;
            if (button.getAttribute('data-spclst-color-category') !== colorToken) continue;

            return button;
          }
        }

        return null;
      }

      function setSelectedOptionsFromVariant(variant) {
        if (!variant || !variant.options) return;

        optionButtons.forEach(function (button) {
          var optionIndex = parseInt(button.getAttribute('data-option-index') || '0', 10);
          var isActive = variant.options[optionIndex] === button.getAttribute('data-option-value');

          button.classList.toggle('is-active', isActive);
          updateOptionVisualState(button, isActive);
        });
      }

      function clearActiveSizeSelection() {
        optionButtons.forEach(function (button) {
          if (button.getAttribute('data-option-kind') !== 'size' || !button.classList.contains('is-active')) return;
          button.classList.remove('is-active');
          updateOptionVisualState(button, false);
        });
      }

      function syncColorLabel(variant) {
        if (!colorLabel) return;

        var defaultLabel = colorLabel.getAttribute('data-spclst-color-default-label') || 'COLOR';
        colorLabel.textContent = variant && variant.available === false ? 'SOLD OUT' : defaultLabel;
      }

      function syncOptionAvailability() {
        var selectedOptions = getSelectedOptions();

        optionButtons.forEach(function (button) {
          var optionKind = button.getAttribute('data-option-kind');
          var testSelection = optionKind === 'color' ? {} : Object.assign({}, selectedOptions);
          var optionIndex = button.getAttribute('data-option-index');
          testSelection[optionIndex] = button.getAttribute('data-option-value');

          var matchingVariantExists = variants.some(function (variant) {
            return selectionMatchesVariant(variant, testSelection);
          });

          var availableVariantExists = variants.some(function (variant) {
            return variant.available && selectionMatchesVariant(variant, testSelection);
          });

          // Match the PDP: sold-out colors remain selectable so their media and
          // sold-out state can be viewed. Size choices retain disabled behavior.
          button.disabled = optionKind !== 'color' && !availableVariantExists;
          button.classList.toggle('sf-option-unavailable', !matchingVariantExists);
          button.classList.toggle('sf-out-of-stock', !availableVariantExists && matchingVariantExists);
          button.classList.toggle('is-unavailable', !availableVariantExists);
          button.setAttribute('aria-disabled', button.disabled ? 'true' : 'false');

          if (optionKind === 'color') {
            var optionValue = button.getAttribute('data-option-value') || '';
            button.setAttribute('aria-label', optionValue + (availableVariantExists ? '' : ', sold out'));
          }

          var colorText = query('.colorblock', button);
          var sizeText = query('.plpsizeselectortext', button);

          if (colorText) {
            colorText.classList.toggle('sf-option-unavailable', !matchingVariantExists);
            colorText.classList.toggle('sf-out-of-stock', !availableVariantExists && matchingVariantExists);
          }

          if (sizeText) {
            sizeText.classList.toggle('sf-option-unavailable', !matchingVariantExists);
            sizeText.classList.toggle('sf-out-of-stock', !availableVariantExists && matchingVariantExists);
          }
        });
      }

      function syncVariant(explicitVariant) {
        var selectedOptions = getSelectedOptions();
        var variant = explicitVariant || findVariant(selectedOptions) || findBestAvailableVariant(selectedOptions);
        if (!variant) return;

        currentVariant = variant;
        setSelectedOptionsFromVariant(variant);
        syncColorLabel(variant);

        if (gallery) {
          selectedBaseMediaId = getVariantMediaId(variant) || selectedBaseMediaId || gallery.getActiveMediaId();
          gallery.setByMediaId(selectedBaseMediaId);

          if (cardRoot.classList.contains('is-gallery-hovered') && shouldUseDesktopHoverNextImage()) {
            galleryHoverPreviewActive = false;
            showDesktopHoverPreview();
          } else {
            galleryHoverPreviewActive = false;
          }
        }

        if (variantInput) variantInput.value = variant.id;
        if (priceEl) priceEl.textContent = formatMoney(variant.price);

        var isOnSale = variantIsOnSale(variant);

        if (priceWrapEl) {
          priceWrapEl.classList.toggle('is-on-sale', isOnSale);
        }

        if (priceEl) {
          priceEl.classList.toggle('price-thumbnail--sale', hasSaleTreatment && isOnSale);
        }

        if (comparePriceEl) {
          if (isOnSale) {
            comparePriceEl.hidden = false;
            comparePriceEl.textContent = formatMoney(getCompareAtPrice(variant));
          } else {
            comparePriceEl.hidden = true;
            comparePriceEl.textContent = '';
          }
        }

        if (saleBadgeEl) {
          if (isOnSale) {
            saleBadgeEl.hidden = false;
            saleBadgeEl.textContent = getVariantSalePercent(variant) + '% OFF';
          } else {
            saleBadgeEl.hidden = true;
            saleBadgeEl.textContent = '';
          }
        }

        if (addButton) {
          addButton.disabled = !variant.available;
          addButton.classList.toggle('sf-out-of-stock', !variant.available);
          addButton.setAttribute('aria-disabled', variant.available ? 'false' : 'true');
          if (addButtonLabel) addButtonLabel.classList.toggle('sf-out-of-stock', !variant.available);
          if (outOfStockLabel) outOfStockLabel.classList.toggle('sf-out-of-stock', !variant.available);
        }

        syncOptionAvailability();
      }

      function syncPartialSelection() {
        var selectedOptions = getSelectedOptions();
        var representativeVariant = findBestAvailableVariant(selectedOptions);
        var hasAvailableMatch = variants.some(function (variant) {
          return variant.available && selectionMatchesVariant(variant, selectedOptions);
        });

        if (representativeVariant) {
          syncVariant(representativeVariant);
          clearActiveSizeSelection();
        }

        if (variantInput) variantInput.value = '';
        if (addButton) {
          addButton.disabled = true;
          addButton.classList.toggle('sf-out-of-stock', !hasAvailableMatch);
          addButton.setAttribute('aria-disabled', 'true');
          if (addButtonLabel) addButtonLabel.classList.toggle('sf-out-of-stock', !hasAvailableMatch);
          if (outOfStockLabel) outOfStockLabel.classList.toggle('sf-out-of-stock', !hasAvailableMatch);
        }

        syncColorLabel(representativeVariant);
        syncOptionAvailability();
      }

      function applyColorFilterSelection(activeColorFilters) {
        if (!activeColorFilters || !activeColorFilters.length) {
          var defaultVariant = findVariantById(defaultVariantId);
          if (defaultVariant) syncVariant(defaultVariant);
          return;
        }

        var matchingColorButton = findFirstColorButtonForCategory(activeColorFilters);
        if (!matchingColorButton) return;

        var selectedOptions = getSelectedOptions();
        var optionIndex = parseInt(matchingColorButton.getAttribute('data-option-index') || '0', 10);
        var optionValue = matchingColorButton.getAttribute('data-option-value');
        var filterVariant = findBestVariantForColor(optionIndex, optionValue, selectedOptions);

        if (filterVariant) {
          syncVariant(filterVariant);
        }
      }

      optionButtons.forEach(function (button) {
        button.addEventListener('click', function () {
          if (button.disabled) return;

          var optionIndex = button.getAttribute('data-option-index');
          var optionKind = button.getAttribute('data-option-kind');

          if (optionKind === 'color') {
            var nextSelection = getSelectedOptions();
            nextSelection[optionIndex] = button.getAttribute('data-option-value');
            var nextVariant = findVariant(nextSelection);

            if (!nextVariant || !nextVariant.available) {
              clearActiveSizeSelection();
            }
          }

          queryAll('[data-option-index="' + optionIndex + '"]', cardRoot).forEach(function (peer) {
            peer.classList.remove('is-active');
            updateOptionVisualState(peer, false);
          });

          button.classList.add('is-active');
          updateOptionVisualState(button, true);

          var selectedOptions = getSelectedOptions();
          var optionCount = variants[0] && Array.isArray(variants[0].options) ? variants[0].options.length : 0;
          var selectionComplete = optionCount > 0;

          for (var selectedIndex = 0; selectedIndex < optionCount; selectedIndex += 1) {
            if (!selectedOptions[String(selectedIndex)]) selectionComplete = false;
          }

          if (selectionComplete) {
            syncVariant(findVariant(selectedOptions));
          } else {
            syncPartialSelection();
          }
        });
      });

      syncVariant();
      applyColorFilterSelection(getCollectionFilterState().color || []);
      cardRoot.spclstApplyColorFilterSelection = applyColorFilterSelection;
    });
  };
})();
